// @ vendors
const { Promise } = require('es6-promise');
// @ actions
const notification = require('actions/notifications');
const signaturePatternActions = require('actions/signaturePattern');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');


const setAccessKeyInProgress = () => ({
    type: actionTypes.SET_ACCESS_KEY_CHANGE_REQUEST
});

const setAccessKeySuccess = () => ({
    type: actionTypes.SET_ACCESS_KEY_CHANGE_SUCCESS
});

const setAccessKeyFailure = error => ({
    type: actionTypes.SET_ACCESS_KEY_CHANGE_FAILURE,
    payload: {
        error
    }
});

const reset = () => ({
    type: actionTypes.ACCESS_KEY_CHANGE_RESET
});

const setWillLeave = () => ({
    type: actionTypes.ACCESS_KEY_CHANGE_WILL_LEAVE
});

const requestAccessKeyDataInProgress = () => ({
    type: actionTypes.FETCH_ACCESS_KEY_DATA_REQUEST
});

const requestAccessKeyDataSuccess = data => ({
    type: actionTypes.FETCH_ACCESS_KEY_DATA_SUCCESS,
    payload: {
        cmcContract: {
            lastName: data.contratoCmc.apellido,
            secondLastName: data.contratoCmc.apellido2,
            contract: {
                contractNumber: data.contratoCmc.contrato.numerodecontrato,
                product: data.contratoCmc.contrato.producto
            },
            dateOfBirth: data.contratoCmc.fechaNacimiento,
            name: data.contratoCmc.nombre,
            organizationName: data.contratoCmc.nombreOrganizacion,
            uid: data.contratoCmc.uid,
            lastAccess: data.contratoCmc.ultimoAcceso ? data.contratoCmc.ultimoAcceso : '',
            keyChange: data.contratoCmc.cambioClave ? data.contratoCmc.cambioClave : '',
            keyEcommerceChange: data.fechaCambioClaveEcommerce ? data.fechaCambioClaveEcommerce : '',
            keySignature: data.contratoCmc.fechaCambioFirma ? data.contratoCmc.fechaCambioFirma : '',
        }
    }
});

const requestAccessKeyDataFailure = error => ({
    type: actionTypes.FETCH_ACCESS_KEY_DATA_FAILURE,
    payload: {
        error
    }
});

const setField = (inputField, data) => ({
    type: actionTypes.ACCESS_KEY_CHANGE_SET_FIELD,
    payload: {
        inputField,
        data
    }
});

const setVisibleStep = step => ({
    type: actionTypes.ACCESS_KEY_CHANGE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillCancel = willCancel => ({
    type: actionTypes.ACCESS_KEY_CHANGE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const validateStep = step => ({
    type: actionTypes.ACCESS_KEY_CHANGE_VALIDATE_STEP,
    payload: {
        step
    }
});

const setAccessKey = (dispatch, data) =>
    new Promise(() => {
        const requestData = {
            query: data
        };

        dispatch(setAccessKeyInProgress());
        APIPost(dispatch, apiURLBuilder.getURL('accessKeyChange'), requestData).then(
            () => {
                dispatch(setAccessKeySuccess());
            },
            () => {
                const message = formatText('profileKeys-editFailure');
                dispatch(notification.error({ message }, { voice: message }));
                dispatch(setAccessKeyFailure(data));
            }
        );
    });

const postChange = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const accessKeyChange = getState().accessKeyChange;
        const step = accessKeyChange.get('steps').get('0');
        const data = {
            dataToken: dataToken,
            nuevaPass: step.get('newKey'),
            passcode: step.get('confirmKey'),
            uid: accessKeyChange.getIn(['cmcContract', 'uid'])
        };

        setAccessKey(dispatch, data);
    };
    const accessKeyChange = getState().accessKeyChange;
    const isAlreadyFetching = accessKeyChange.get('isFetching');
    const hasError = accessKeyChange.get('errorReceived') !== '';

    if (!isAlreadyFetching && !hasError) {
        new Promise(function () {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

const cancel = () => dispatch => {
    const message = formatText('profileKeys-toasterMessage');
    dispatch(notification.error({ message }, { voice: message }));
};

const requestAccessKeyData = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().accessKeyChange.get('isFetching');

    if (!isAlreadyFetching) {
        return new Promise(() => {
            const requestData = {};

            dispatch(requestAccessKeyDataInProgress());
            APIGet(dispatch, apiURLBuilder.getURL('requestAccessKeyData'), requestData).then(
                response => {
                    if (response) {
                        dispatch(requestAccessKeyDataSuccess(response))
                    }
                },
                error => dispatch(requestAccessKeyDataFailure(error))
            );
        });
    }
};

module.exports = {
    cancel,
    postChange,
    reset,
    requestAccessKeyData,
    setField,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    validateStep
};
